import React from "react";
import { lazy } from "react";

import { Route, Routes } from "react-router-dom";

const ProducListPage = lazy(() =>
  import("../Interface/Products/ProducListPage")
);
const ProdDescrip = lazy(() =>
  import("../Interface/Products/ProductDescription/ProdDescrip")
);

const Cart = lazy(() => import("../Interface/Components/Cart"));

const ProductRoute = () => {
  return (
    <Routes>
      <Route
        index
        element={
          <React.Suspense fallback={<div>Loading..</div>}>
            <ProducListPage />
          </React.Suspense>
        }
      ></Route>
      <Route
        path=":id"
        element={
          <React.Suspense fallback={<div>Loading..</div>}>
            <ProdDescrip />
          </React.Suspense>
        }
      ></Route>

      <Route
        path="cart"
        element={
          <React.Suspense fallback={<div>Loading..</div>}>
            <Cart />
          </React.Suspense>
        }
      ></Route>
    </Routes>
  );
};

export default ProductRoute;
